<template>
    <div class="bg-gray-relative-100 mh-vh-100-nav p-3">
        <SubHeader title="결제대기"></SubHeader>
        <ul class="category flex-start-center fs-px-13 fw-bold gap-2 mb-3">
            <li
                class="rounded-pill py-2 px-3 bg-gray-relative-200"
                :class="{ 'bg-main text-white': sort_key === 'date' }"
                @click="ToggleSort('date')"
            >
                예약일자<i class="fas ms-1" :class="SortIcon('date')" v-if="sort_key === 'date'"></i>
            </li>
            <li
                class="rounded-pill py-2 px-3 bg-gray-relative-200"
                :class="{ 'bg-main text-white': sort_key === 'create_time' }"
                @click="ToggleSort('create_time')"
            >
                신청날짜<i class="fas ms-1" :class="SortIcon('create_time')" v-if="sort_key === 'create_time'"></i>
            </li>
        </ul>
        <ReservationItem :list="sorted_list" />
    </div>
</template>

<script>
import SubHeader from '@/components/common/SubHeader.vue'
import ReservationItem from '@/components/reservation/ReservationItem.vue'
const CryptoJS = require("crypto-js");

export default {
    name: 'ReservationWait',
    components:{
        SubHeader, ReservationItem
    },
    data(){
        return{
            list:[],
            sort_key: null,
            sort_dir: 1,
        }
    },
    computed: {
        sorted_list() {
            if (!this.sort_key) return this.list;
            const key = this.sort_key;
            const dir = this.sort_dir;
            return this.list.slice().sort((a, b) => {
                const av = a[key] || '';
                const bv = b[key] || '';
                return av < bv ? -dir : av > bv ? dir : 0;
            });
        },
    },
    activated(){
        this.GetReservationHistoryList();
    },
    methods:{
        ToggleSort(key) {
            if (this.sort_key === key) {
                this.sort_dir *= -1;
            } else {
                this.sort_key = key;
                this.sort_dir = 1;
            }
        },
        SortIcon(key) {
            if (this.sort_key !== key) return '';
            return this.sort_dir === 1 ? 'fa-arrow-down' : 'fa-arrow-up';
        },
        GetReservationHistoryList(){
            const body = {};
            const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
            this.loading = true;
            this.$http.post('/shop/reservation/GetReservationHistoryWaitList',{req}).then(
                (res) =>  { 
                    if(res.status == 200){
                        this.loading = false;
                        if(res.data.code =="200"){
                            const e_body = res.data.body;
                            const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
                            const d_res = bytes.toString(CryptoJS.enc.Utf8);
                            const body = JSON.parse(d_res)
                            this.list = body.list;
                        }
                    }
                }
            );
        },
    }
}
</script>

<style>

</style>